import * as S from './styles'

export type BadgeAppearance = 'solid' | 'soft' | 'outline' | 'surface' | 'ping'
export type BadgeColor = 'info' | 'neutral' | 'success' | 'danger' | 'warning'
export type BadgeSize = 'medium' | 'small'

export interface BadgeProps {
  appearance?: BadgeAppearance
  color?: BadgeColor
  size?: BadgeSize
  children?: React.ReactNode
}

export const Badge = ({
  appearance = 'solid',
  color = 'neutral',
  size = 'small',
  children,
}: BadgeProps) => {
  const showLabel = appearance !== 'ping' && children

  return (
    <S.Container appearance={appearance} color={color} data-testid="badge" size={size}>
      {showLabel && <S.Label>{children}</S.Label>}
    </S.Container>
  )
}
